import React, { useState } from "react";
import {
    Box,
    VStack,
    Stack,
    Text,
    Heading,
    List,
    ListItem,
    ListIcon,
    Link,
    Divider,
    useMediaQuery,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import FAQModal from "./FAQModal";
import { PhoneIcon } from "@chakra-ui/icons";
import { FaMailBulk, FaLinkedin } from "react-icons/fa";
import { useDirection } from "../../context/DirectionContext";

const Footer = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const { direction } = useDirection();
    const [isMobileView] = useMediaQuery("(max-width: 991px)");

    return (
        <Box bg="#4FBA64" color="white" pt={10} mt={isMobileView ? 10 : 100}>
            <Stack
                direction={{ base: "column", md: "row" }}
                spacing={{ base: 6, md: 10 }}
                width={{ base: "90%", md: "85%" }}
                maxW="1200px"
                mx="auto"
                justify="space-between"
                align={{ base: "center", md: "flex-start" }}
                textAlign={{ base: "center", md: "left" }}
            >
                {/* Column 1 */}
                <VStack align={{ base: "center", md: "flex-start" }} spacing={2}>
                    <Heading fontSize="lg">{t("company")}</Heading>
                    <Link onClick={() => navigate("/aboutus")}>{t("navbar.aboutUs")}</Link>
                    <Link onClick={() => setIsOpen(true)}>{t("faq")}</Link>
                    <Link onClick={() => navigate("/aboutus/#contactus")}>
                        {t("support")}
                    </Link>
                </VStack>

                {/* Column 2 */}
                <VStack
                    align={{ base: "center", md: "flex-start" }}
                    spacing={2}
                    sx={{ wordBreak: "break-word", overflowWrap: "break-word" }}
                >
                    <Heading fontSize="lg">{t("others")}</Heading>
                    <List spacing={2}>
                        <ListItem>
                            <Link href="/impressum/#impressum">{t("impressum_tab")}</Link>
                        </ListItem>
                        <ListItem>
                            <Link href="/privacy-policy/#policy">
                                {t("join_study.policy")}
                            </Link>
                        </ListItem>
                    </List>
                </VStack>

                {/* Column 3 */}
                <VStack align={{ base: "center", md: "flex-start" }} spacing={2}>
                    <Heading fontSize="lg">{t("contacts")}</Heading>
                    <List spacing={2}>
                        <ListItem>
                            <ListIcon as={PhoneIcon} /> +49 15560676362
                        </ListItem>
                        <ListItem>
                            <ListIcon as={FaMailBulk} />
                            <Link href="mailto:neurobee@vitafluence.ai" isExternal>
                                neurobee@vitafluence.ai
                            </Link>
                        </ListItem>
                        <Divider borderColor="whiteAlpha.500" />
                        <ListItem>
                            <ListIcon as={FaLinkedin} />
                            <Link
                                href="https://www.linkedin.com/company/vitafluence/posts/?feedView=all"
                                isExternal
                            >
                                {t("linkedIn")}
                            </Link>
                        </ListItem>
                    </List>
                </VStack>
            </Stack>

            <Text textAlign="center" mt={6} fontSize="sm" opacity={0.8}>
                {t("copyright")}
            </Text>

            <FAQModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </Box>
    );
};

export default Footer;
